import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { Suspense } from 'react';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Header />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>}>
        <AppRoutes />
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
